import { render } from "./ListDoctorCheck.vue?vue&type=template&id=678578b7"
import script from "./ListDoctorCheck.vue?vue&type=script&lang=js"
export * from "./ListDoctorCheck.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__